import {
  SelectOption,
  selectOptionActions,
} from "@/business/shared/commons/selectOption";
import { ClientList } from "../domain/clients";

export const getClientsLikeSelectOption = {
  async execute(clients: ClientList[]): Promise<SelectOption[]> {
    return clients.map((client) =>
      selectOptionActions().create(client.clientId, client.company)
    );
  },
};
